<template>
    <div class="all">
        <van-nav-bar
                :title="this.query.titleName"
                left-text="返回"
                right-text
                left-arrow
                @click-left="$goBack()"
                @click-right

        />
        <template>
            <div class="task" v-for="task in showTaskList" :key="task.id" v-if="showTaskList&&showTaskList.length!=0">
                <van-row>
                    {{task.name}}
                </van-row>

                <van-row justify="space-around">
                    <van-col span="18">
                        <van-row>
                            {{task.ruleDesc}}
                        </van-row>
                    </van-col>
                    <van-col span="6" style="text-align:right">
                        <van-button round size="small" @click="setprice(task.id)" style="width:6rem;">
                            统一设价
                        </van-button>
                        <van-button round size="small" @click="queryTaskShare(task.id)" style="width:6rem;">
                            {{task.traderId?'查看分享':'立即报名'}}
                        </van-button>
                    </van-col>
                </van-row>

                <van-row class="line">
                    <van-col span="24" class="commission">单价</van-col>
                    <van-col span="12" v-for="(value,index) in task.jobItemJoinPriceList" :key="index" style="padding-top: 0;">
                        {{value.name}}：<span class="commission" v-if="value.extendsPriceRMB">{{value.extendsPriceRMB}}{{value.mode === 1 ? '%' : '元'}}</span>
                    </van-col>
                </van-row>

                <!--<van-row class="line">-->
                    <!--<van-col span="12">领取人数：<span class="commission">{{task.count}}</span></van-col>-->
                    <!--<van-col span="12">累计发放：<span class="commission">{{task.amountRMB}}</span></van-col>-->
                <!--</van-row>-->

                <van-row>
                    <van-col span="16" class="tag">
                        <van-row>
                            <van-col span="6" v-for="tag in task.tags" :key="tag" style="padding:0 2.5px 0 0">
                                <span> {{tag}}</span>
                            </van-col>
                        </van-row>
                    </van-col>
                    <van-col span="8" class="signCount">
                        <div style="display: flex;justify-content:flex-end;margin-top:0.45rem">
                            <div style="margin-right:5px"><img :src="tuandui"></div>
                            <div>已报名:{{task.count?task.count:'0'}}</div>
                        </div>
                    </van-col>
                </van-row>
            </div>

            <div class="imgShow" v-else>
                <img :src="noFound">
                <p>
                    您还没有任务哦～
                    <router-link to="/main">去首页领取任务</router-link>
                </p>
            </div>
        </template>
    </div>
</template>

<script>
    // import tuijianzhishu from '@/assets/images/tuijianzhishu.png'
    import tuandui from '@/assets/images/tuandui.png'
    import noFound from '@/assets/images/noFound.png'
    import mainAPI from '@/api/main'

    export default {
        data() {
            return {
                tuandui: tuandui,
                noFound: noFound,
                showTaskList: [],
                id: '',

                query: {
                    classId: this.$route.query.classId,
                    titleName: this.$route.query.titleName,
                    jobIdStr: this.$route.query.jobIdStr,
                    excludeJobIdStr: this.$route.query.excludeJobIdStr,
                },
            }
        },

        created() {
            this.list()
        },
        methods: {
            queryTaskShare(id) {
                this.$router.push('/main/task/share?id=' + id)
            },
            list() {
                this.$toast.loading({forbidClick: true})
                mainAPI.list(this.query).then((result) => {
                    this.showTaskList = result.data
                    this.$toast.clear()
                })
            },
        setprice(id){
            ///jobItemPrice?traderId=10078
            this.$router.push('/user/jobItemPrice?action=setPrice&jobId=' + id)
        }
        }
    }
</script>

<style lang="scss" scoped>

    * {
        margin: 0;
    }

    .all {
        background-color: #fff;
    }

    .task {
        padding: 0.5rem 1rem;
        margin: 1rem;
        border-left: 3px solid #ee9900;
        -moz-box-shadow: 0 0 10px #e5e5e5;
        -webkit-box-shadow: 0 0 10px #e5e5e5;
        box-shadow: 0 0 10px #e5e5e5;

        .van-col {
            font-size: 1.1rem;
            color: #8b8b8b;
            padding-top: 1rem;
            padding-bottom: 0.5rem;

            .van-button {
                background-color: #ee9900;
                color: #fff;
            }

        }

        .line {
            border-bottom: 1px dashed #e5e5e5;
        }


        .tag span {
            text-align: center;
            font-size: 1rem;
            display: block;
            color: #ee9900;
            border: 1px solid #FEC82E;
            padding: 0.25rem 0rem;
        }

        .signCount {
            font-size: 1rem;
            color: #ee9900;

            img {
                height: 1.3rem;
                width: 1.2rem;
            }
        }

        .newUser {
            color: #3399ff;
        }

        .commission {
            color: #ee9900;
        }
    }

    .imgShow {
        padding: 20% 10%;
        text-align: center;
        font-size: 1.2rem;

        a {
            text-decoration: underline;
            color: #ee9900;
        }
    }

</style>
